require('dotenv').config()
const ethers = require('ethers')

const getPrivKey = async mnemonic => {
  let mnemonicWallet = ethers.Wallet.fromMnemonic(mnemonic)
  let address = await mnemonicWallet.getAddress()

  return new Promise((resolve, reject) => {
    try {
      let credentials = {
        PrivateKey: mnemonicWallet.privateKey,
        Address: address
      }
      resolve(credentials)
    } catch (error) {
      reject(error)
    }
  })
}

export { getPrivKey }
